'use client'

/**
 * Mémorise la source publicitaire de l'arrivée sur le site (gclid, gbraid,
 * wbraid, utm_*), pour la joindre plus tard à une demande d'ENTREPRISE.
 * Règles et durées : src/lib/acquisition/origine.ts.
 *
 * Monté une fois dans le layout public, HORS d'AnalyticsGate : il doit lire
 * l'adresse d'ARRIVÉE même si le visiteur n'a pas encore répondu au
 * bandeau. Tant qu'il n'a pas accepté, l'origine reste en mémoire vive (rien
 * n'est écrit) ; elle n'est gardée qu'au moment où il accepte la mesure
 * des campagnes publicitaires, et effacée s'il refuse ou s'oppose. Ne rend rien.
 */
import { useEffect } from 'react'
import { CONSENT_EVENT } from '@/lib/consent'
import { lireOrigineDepuisAdresse, memoriserOrigine } from '@/lib/acquisition/origine'

export default function MemoireOrigine() {
  useEffect(() => {
    // Adresse d'arrivée : lue une seule fois, au premier affichage.
    const arrivee = lireOrigineDepuisAdresse(window.location.search)
    memoriserOrigine(arrivee)
    // Choix fait plus tard sur le bandeau : on garde (accord) ou on efface (refus).
    const surChoix = () => memoriserOrigine(arrivee)
    window.addEventListener(CONSENT_EVENT, surChoix)
    return () => window.removeEventListener(CONSENT_EVENT, surChoix)
  }, [])
  return null
}
